/* React hooks */
import {useEffect, useState} from "react";
/* Resources */
/* Components */
import useData from "../../../hooks/useData";
import {getAgencyBillingInfos} from "../../../api/admin/agencyReq";
import {useParams} from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import {getProductList} from "../../../api/admin/productReq";
import FormAgencyBilling from "../../../forms/admin/agency/FormAgencyBilling";
import Icon from "../../../components/common/Icon";


export default function ViewAgencyBilling() {
    const {
        billingAgencyList,
        agencyBilling, setAgencyBilling
    } = useData();

    const { id } = useParams();
    const {auth} = useAuth();
    const token = auth.token;

    const [ values, setValues ] = useState();
    const [ showModal, setShowModal ] = useState(false);

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
    };

    const [ productList, setProductList ] = useState();

    const apiAgencyBilling = async () => {
        const response = await getAgencyBillingInfos(token, id);
        setAgencyBilling(response)
    };

    const apiProductList = async () => {
        const response = await getProductList(token);
        setProductList(response)
    }

    const handleAgencyBillingModal = (e) => {
        e.preventDefault()
        setShowModal(true)
    };

    useEffect(() => {
        apiAgencyBilling()
        apiProductList()
    }, [ id ])

    return (
        <>
            { showModal &&
                <div className="modal billing-infos">
                    <FormAgencyBilling apiAgencyBilling={apiAgencyBilling} setShowModal={setShowModal} legend="Modification des infos de facturation"/>
                </div>
            }
            <form>
                <fieldset className="mini">
                    <Icon source="fa fa-file-invoice-dollar" span="Informations de facturation"/>
                    <div className="form-input">
                        <label>Facturation</label>
                        <span>{agencyBilling?.billing ? "Oui" : "Non"}</span>
                    </div>
                    <div className="form-input">
                        <label>Au forfait</label>
                        <span>{agencyBilling?.flateRate ? "Oui" : "Non"}</span>
                    </div>
                    <div className="form-input">
                        <label>Site partenaire</label>
                        <span>{agencyBilling?.templateOnline ? "Oui" : "Non"}</span>
                    </div>
                    <div className="form-input">
                        <label>Agence de facturation</label>
                        <span>{agencyBilling?.billingAgencyName}</span>
                    </div>
                    <div className="form-input">
                        <label>A une adresse mail de facturation</label>
                        <span>{agencyBilling?.hasBillingEmail ? "Oui" : "Non"}</span>
                    </div>
                    {agencyBilling?.hasBillingEmail == 1 &&
                        <div className="form-input">
                            <label>Adresse mail de facturation</label>
                            <span>{agencyBilling?.billingEmail}</span>
                        </div>
                    }
                    <div className="form-input">
                        <label>Numéro de facture</label>
                        <span>{agencyBilling?.invoiceNumber}</span>
                    </div>
                    <div className="form-input">
                        <label>Référence contrat OEF</label>
                        <span>{agencyBilling?.contractReference}</span>
                    </div>
                    <div className="form-input">
                        <label>Nombre de défunts</label>
                        <span>{agencyBilling?.deceasedNumber}</span>
                    </div>
                    <div className="form-input">
                        <label>Nombre de sites</label>
                        <span>{agencyBilling?.templateNumber}</span>
                    </div>
                    <div className="form-input">
                        <label>Prix défunt unitaire (H.T.)</label>
                        <span>{agencyBilling?.deceasedPrice}</span>
                    </div>
                    <div className="form-input">
                        <label>Prix site unitaire (H.T.)</label>
                        <span>{agencyBilling?.templatePrice}</span>
                    </div>
                    <div className="form-input">
                        <label>Réductions accordée pour les défunts (%)</label>
                        <span>{agencyBilling?.deceasedReduct}</span>
                    </div>
                    <div className="form-input">
                        <label>Réduction accordée pour les sites (€)</label>
                        <span>{agencyBilling?.templateReduct}</span>
                    </div>
                </fieldset>
                <div className="buttons-container">
                    <button className="red-button" onClick={handleAgencyBillingModal}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                </div>
            </form>
        </>

    )
}